var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSorting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#4C4C4C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.753 11.8628H18.2356V25.5174C18.2356 25.7459 18.4209 25.9311 18.6494 25.9311H22.7872C23.0157 25.9311 23.2009 25.7459 23.2009 25.5174V11.8628H25.6836C25.837 11.8639 25.9781 11.7789 26.0488 11.6427C26.1196 11.5065 26.1079 11.3422 26.0187 11.2173L21.0659 4.17072C20.9879 4.06346 20.8633 4 20.7307 4C20.5981 4 20.4735 4.06346 20.3955 4.17072L19.1046 5.9996L16.2371 10.0587L15.4178 11.2173C15.3286 11.3422 15.317 11.5065 15.3877 11.6427C15.4584 11.7789 15.5995 11.8639 15.753 11.8628Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89531 21.9417L8.76277 26.0008L10.0537 27.8297C10.1317 27.9369 10.2563 28.0004 10.3889 28.0004C10.5215 28.0004 10.6461 27.9369 10.7241 27.8297L15.6769 20.7831C15.7661 20.6582 15.7778 20.4939 15.707 20.3577C15.6363 20.2215 15.4952 20.1365 15.3418 20.1376H12.8591V6.48409C12.8591 6.25557 12.6739 6.07031 12.4454 6.07031H8.30761C8.07909 6.07031 7.89384 6.25557 7.89384 6.48409V20.1376H5.41119C5.25775 20.1365 5.11664 20.2215 5.04593 20.3577C4.97522 20.4939 4.98685 20.6582 5.07603 20.7831L5.89531 21.9417Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSorting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sorting.7efff45eb89700aa3c3cb0eb793a0783.svg";